import { useIntl } from "react-intl";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  const translations = {
    yourInformationHeader: formatMessage(messages.yourInformationHeader),
    yourInformationDesc: formatMessage(messages.yourInformationDesc),
    emailLabel: formatMessage(messages.emailLabel),
    phoneNumberLabel: formatMessage(messages.phoneNumberLabel),
    firstNameLabel: formatMessage(messages.firstNameLabel),
    lastNameLabel: formatMessage(messages.lastNameLabel),
    patientInformationHeader: formatMessage(messages.patientInformationHeader),
    patientInformationDesc: formatMessage(messages.patientInformationDesc),
    patientInformationDescAttention: formatMessage(
      messages.patientInformationDescAttention,
    ),
    dateOfBirthLabel: formatMessage(messages.dateOfBirthLabel),
    dateOfBirthPlaceholder: formatMessage(messages.dateOfBirthPlaceholder),
    pregnantHeader: formatMessage(messages.pregnantHeader),
    answerYes: formatMessage(messages.answerYes),
    answerNo: formatMessage(messages.answerNo),
    answerIdk: formatMessage(messages.answerIdk),
    wearingDeviceHeader: formatMessage(messages.wearingDeviceHeader),
    emailCheckDialogTitle: formatMessage(messages.emailCheckDialogTitle),
    emailCheckDialogExplanation: formatMessage(
      messages.emailCheckDialogExplanation,
    ),
    changeEmailButton: formatMessage(messages.changeEmailButton),
    okButton: formatMessage(messages.okButton),
    mobilePhoneNumberHelper: formatMessage(messages.mobilePhoneNumberHelper),
    dateOfBirthHelper: formatMessage(messages.dateOfBirthHelper),
    heightFtLabel: formatMessage(messages.heightFtLabel),
    heightInLabel: formatMessage(messages.heightInLabel),
    weightLbsLabel: formatMessage(messages.weightLbsLabel),
  };

  return translations;
};

export default useTranslations;
